<template>
  <v-row no-gutters class="pt-5">
    <v-col class="pr-2">
      <card-title-row translation-path="sidebar.modelingRules" />
      <modeling-rule-row
        translation-path="sidebar.simpleRules"
        rule-type="control"
        :rules="simpleRules"
        @editRule="openRuleDialog"
        @addRule="addRule"
        @deleteRule="handleDelete"
      ></modeling-rule-row>
      <modeling-rule-row
        translation-path="sidebar.advancedRules"
        rule-type="rule"
        :rules="advancedRules"
        @editRule="openRuleDialog"
        @addRule="addRule"
        @deleteRule="handleDelete"
      ></modeling-rule-row>
    </v-col>
    <modeling-rule-dialog
      v-if="isRuleDialogLoaded"
      :is-visible.sync="isRuleDialogVisible"
      :rule="editingRule"
      @modalClosed="resetData"
    ></modeling-rule-dialog>
  </v-row>
</template>

<script>
import CardTitleRow from '@/components/CardTitleRow';
import ModelingRuleRow from '@/components/ModelingRuleRow';
import { call, get } from 'vuex-pathify';
export default {
  name: 'ModelingRules',
  components: {
    ModelingRuleRow,
    CardTitleRow,
    ModelingRuleDialog: () => import('@/components/ModelingRuleDialog'),
  },
  data: () => ({
    isRuleDialogVisible: false,
    isRuleDialogLoaded: false,
    editingRule: undefined,
  }),
  computed: {
    rules: get('epanet/rules'),
    advancedRules() {
      return this.rules.filter(r => r.rule_type === 'rule');
    },
    simpleRules() {
      return this.rules.filter(r => r.rule_type === 'control');
    },
  },
  methods: {
    getRules: call('epanet/getRules'),
    deleteRule: call('epanet/deleteRule'),
    async handleDelete(rule_id) {
      await this.deleteRule(rule_id);
    },
    addRule(e) {
      this.isRuleDialogVisible = true;
      this.isRuleDialogLoaded = true;
      this.editingRule = {
        name: '',
        rule_type: e.type,
        rule_text: '',
      };
    },
    openRuleDialog(e) {
      this.isRuleDialogVisible = true;
      this.isRuleDialogLoaded = true;
      this.editingRule = e;
    },
    async init() {
      await this.getRules();
    },
    resetData() {
      this.editingRule = undefined;
      this.isRuleDialogVisible = false;
      this.isRuleDialogLoaded = false;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
